// Automatically generated
export const USE_DATE_PICKER_STATE_KEYS = [
  "value",
  "defaultValue",
  "onChange",
  "minValue",
  "maxValue",
  "validationState",
  "isRequired",
  "baseId",
  "visible",
  "animated",
  "modal",
  "placement",
  "unstable_fixed",
  "unstable_flip",
  "unstable_offset",
  "gutter",
  "unstable_preventOverflow",
  "isDisabled",
  "isReadOnly",
  "pickerId",
  "dialogId",
  "segmentFocus",
  "formatOptions",
  "placeholderDate",
  "autoFocus",
] as const;
export const DATE_PICKER_STATE_KEYS = [
  "calendar",
  "isDateRangePicker",
  "fieldValue",
  "setFieldValue",
  "segments",
  "dateFormatter",
  "increment",
  "decrement",
  "incrementPage",
  "decrementPage",
  "setSegment",
  "confirmPlaceholder",
  "baseId",
  "unstable_idCountRef",
  "setBaseId",
  "unstable_virtual",
  "rtl",
  "orientation",
  "items",
  "groups",
  "currentId",
  "loop",
  "wrap",
  "shift",
  "unstable_moves",
  "unstable_hasActiveWidget",
  "unstable_includesBaseElement",
  "registerItem",
  "unregisterItem",
  "registerGroup",
  "unregisterGroup",
  "move",
  "next",
  "previous",
  "up",
  "down",
  "first",
  "last",
  "sort",
  "unstable_setVirtual",
  "setRTL",
  "setOrientation",
  "setCurrentId",
  "setLoop",
  "setWrap",
  "setShift",
  "reset",
  "unstable_setIncludesBaseElement",
  "unstable_setHasActiveWidget",
  "visible",
  "animated",
  "animating",
  "show",
  "hide",
  "toggle",
  "setVisible",
  "setAnimated",
  "stopAnimation",
  "modal",
  "unstable_disclosureRef",
  "setModal",
  "unstable_referenceRef",
  "unstable_popoverRef",
  "unstable_arrowRef",
  "unstable_popoverStyles",
  "unstable_arrowStyles",
  "unstable_originalPlacement",
  "unstable_update",
  "placement",
  "place",
  "pickerId",
  "dialogId",
  "isDisabled",
  "isReadOnly",
  "segmentFocus",
  "dateValue",
  "setDateValue",
  "selectDate",
  "validationState",
  "minValue",
  "maxValue",
  "isRequired",
] as const;
export const USE_DATE_RANGE_PICKER_STATE_KEYS = USE_DATE_PICKER_STATE_KEYS;
export const DATE_RANGE_PICKER_STATE_KEYS = [
  "startSegmentState",
  "endSegmentState",
  "calendar",
  "isDateRangePicker",
  "baseId",
  "unstable_idCountRef",
  "visible",
  "animated",
  "animating",
  "setBaseId",
  "show",
  "hide",
  "toggle",
  "setVisible",
  "setAnimated",
  "stopAnimation",
  "modal",
  "unstable_disclosureRef",
  "setModal",
  "unstable_referenceRef",
  "unstable_popoverRef",
  "unstable_arrowRef",
  "unstable_popoverStyles",
  "unstable_arrowStyles",
  "unstable_originalPlacement",
  "unstable_update",
  "placement",
  "place",
  "pickerId",
  "dialogId",
  "isDisabled",
  "isReadOnly",
  "segmentFocus",
  "dateValue",
  "setDateValue",
  "selectDate",
  "validationState",
  "minValue",
  "maxValue",
  "isRequired",
] as const;
export const DATE_PICKER_KEYS = [
  ...DATE_PICKER_STATE_KEYS,
  ...DATE_RANGE_PICKER_STATE_KEYS,
] as const;
export const DATE_PICKER_CONTENT_KEYS = DATE_PICKER_KEYS;
export const DATE_PICKER_SEGMENT_KEYS = DATE_PICKER_CONTENT_KEYS;
export const DATE_PICKER_SEGMENT_FIELD_KEYS = DATE_PICKER_SEGMENT_KEYS;
export const DATE_PICKER_TRIGGER_KEYS = DATE_PICKER_SEGMENT_FIELD_KEYS;
